import { Action } from '../../common/actions/core/action';

export class PaymentProgressChangeAction implements Action {
  constructor(public status: PaymentProgressStatus) {}
}

export enum PaymentProgressStatus {
  INVOICE = 'invoice',
  PAY = 'pay'
}



// WEBPACK FOOTER //
// src/app/components/payment-progress/payment-progress.action.ts